import { render, staticRenderFns } from "./Verimagen.vue?vue&type=template&id=db3272e8&scoped=true"
import script from "./Verimagen.vue?vue&type=script&lang=js"
export * from "./Verimagen.vue?vue&type=script&lang=js"
import style0 from "./Verimagen.vue?vue&type=style&index=0&id=db3272e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3272e8",
  null
  
)

export default component.exports